<template>
  <div class="page">
    <div class="layout">
      <el-row>
        <el-col :span="24">
          <div class="page-title">設定</div>
        </el-col>
      </el-row>
      <div class="page-box" v-for="(item,index) in list" :key="index">
        <div  class="item" @click="onClicked(item.path)">{{item.title}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
       list:[
         {
           title: '回報問題類別',
           path:'/setting/course-sales-statistics'
         },
         {
           title: '分校列表',
           path:'/setting/courseUsageAnalysisReport'
         },
         {
           title: '年級訂閱價格',
           path:'/setting/subscription-price'
         },
         {
           title: '學生平台教學圖片',
           path:'/setting/teaching-picture'
         },
         {
           title: '網頁常見問題',
           path:'/setting/common-problem'
         },
         {
           title: '幫助手冊',
           path:'/setting/common-problem2'
         },
         {
           title: '自動升級時間設定',
           path:'/setting/automatic-upgrade-time'
         },
       ]
    };
  },
  methods: {
    onClicked(path) {
      this.$router.push({ path: path });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  .layout {
    .el-row {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }

      .title {
        font-size: 30px;
      }
    }
    .item {
      display: inline-block;
      color: #166EA5;
      cursor: pointer;
      font-size: 20px;
      border-bottom: 1px solid #166ea5;
    }
  }
}
.page-box{
  background-color: #fff;
  padding: 10px;
}
</style>